import axios from 'axios';

const api = axios.create({
  //baseURL: 'http://localhost',
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});


//header Authorization
api.interceptors.request.use(
(config) => {
    const token = localStorage.getItem("token");
    if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
},
(error) => Promise.reject(error)
);


export default api;